import { render, staticRenderFns } from "./SalOrderItemOrder.vue?vue&type=template&id=62ba1f44&scoped=true"
import script from "./SalOrderItemOrder.vue?vue&type=script&lang=js"
export * from "./SalOrderItemOrder.vue?vue&type=script&lang=js"
import style0 from "./SalOrderItemOrder.vue?vue&type=style&index=0&id=62ba1f44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ba1f44",
  null
  
)

export default component.exports